import { drawing } from '@progress/kendo-drawing';
var _a = drawing.util, elementOffset = _a.elementOffset, limitValue = _a.limitValue;
export { elementOffset, limitValue };
